/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOutAddressAndCoordinates
 */
export interface PropertyOutAddressAndCoordinates {
    /**
     * 
     * @type {string}
     * @memberof PropertyOutAddressAndCoordinates
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutAddressAndCoordinates
     */
    geoLatitude: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutAddressAndCoordinates
     */
    geoLongitude: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutAddressAndCoordinates
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOutAddressAndCoordinates
     */
    modificationDate: Date;
}

export function PropertyOutAddressAndCoordinatesFromJSON(json: any): PropertyOutAddressAndCoordinates {
    return PropertyOutAddressAndCoordinatesFromJSONTyped(json, false);
}

export function PropertyOutAddressAndCoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOutAddressAndCoordinates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'geoLatitude': json['geoLatitude'],
        'geoLongitude': json['geoLongitude'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutAddressAndCoordinatesToJSON(value?: PropertyOutAddressAndCoordinates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'geoLatitude': value.geoLatitude,
        'geoLongitude': value.geoLongitude,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


